/**
 * Origem que pré-preenche o cadastro de produto aberto em modo inclusão (query `origem` + `idOrigem`).
 * Só orienta a carga inicial da tela: nada da origem é gravado com o produto.
 */
export enum OrigemCadastroProdutoEnum {
    CompraItem = 1,
    NFeEntradaItem = 2,
}
